<template>
  <span>
    <span v-if="type === 'problemOccurs'">
      <span
        v-html="$i18nPresenter.t('messageIfProblemStillOccurs')"
      ></span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
  },
}
</script>
